import { Overlay, OverlayPositionBuilder, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Component, InjectionToken, Injector, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { EnrichedTooltipContentComponent } from './enriched-tooltip-content/enriched-tooltip-content.component';

export interface IPayloadEnrichedTooltip {
  mainHeader: string;
  lines: string | string[] | IListEnrichedTooltip[];
}

export interface IListEnrichedTooltip {
  subHeader: string;
  lines: string[];
}

export const TOOLTIP_DATA = new InjectionToken<IPayloadEnrichedTooltip>('');

@Component({
  selector: 'com-enriched-tooltip',
  template: '<mat-icon (mouseenter)="show($event.target)" (mouseleave)="hide()">{{ icon }}</mat-icon>',
  styles: ':host{display: flex;} mat-icon {padding-left: 5px; font-size: 20px; width: 20px; height: 20px;}',
  standalone: true,
  imports: [MatIcon],
})
export class EnrichedTooltipComponent {
  @Input() data: IPayloadEnrichedTooltip;
  @Input() icon: string = 'info';
  overlayRef!: OverlayRef;
  constructor(
    private overlay: Overlay,
    private positionBuilder: OverlayPositionBuilder,
    private injector: Injector
  ) {}

  show(element: HTMLElement) {
    const positionStrategy = this.positionBuilder.flexibleConnectedTo(element).withPositions([
      {
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
        offsetY: 8,
      },
    ]);
    this.overlayRef = this.overlay.create({ positionStrategy, scrollStrategy: this.overlay.scrollStrategies.close(), hasBackdrop: false });
    this.overlayRef.attach(
      new ComponentPortal(
        EnrichedTooltipContentComponent,
        null,
        Injector.create({ providers: [{ provide: TOOLTIP_DATA, useValue: this.data }], parent: this.injector })
      )
    );
  }

  hide() {
    if (this.overlayRef) {
      this.overlayRef.detach();
    }
  }
}
